export default __webpack_public_path__ + "static/javeris-0d64caa5e12f534d0028aca9ed04a7e0.png";